import React from 'react';
import { Button } from '../../Components/Button/Button';
import { SunIcon, MoonIcon, XIcon, DoubleArrowRightIcon, DoubleArrowLeftIcon } from '../../Components/Icons/Icons';
import { useDispatch, useSelector } from "react-redux";
import { setToggleSideBar } from '../../store/UserSlices/ToggleSideBar';
import { setDarkMode } from '../../store/UserSlices/DarkMode';
// import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuSeparator, DropdownMenuItem, DropdownMenuCheckboxItem, DropdownMenuLabel, DropdownMenuShortcut } from '../../Components/Dropdown/Dropdown';
import { Avatar, AvatarImage, AvatarFallback } from '../../Components/Avatar/Avatar';
import { NavLink, useNavigate } from 'react-router-dom';
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import ProfileDropDown from '../../Components/ProfileDropDown/ProfileDropDown';

import { FaBars } from "react-icons/fa";  // Import the hamburger menu icon

const DropdownMenu = DropdownMenuPrimitive.Root;
const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
const DropdownMenuContent = DropdownMenuPrimitive.Content;
const DropdownMenuItem = DropdownMenuPrimitive.Item;
const DropdownMenuSeparator = DropdownMenuPrimitive.Separator;

const Header = () => {



  const dispatch = useDispatch();

  const { darkMode } = useSelector((state) => state.darkMode)
  const { toggleSideBar } = useSelector((state) => state.toggleSideBar);


  const handleToggle = () => {
    dispatch(setToggleSideBar());
  }

  const handleDarkMode = () => {
    dispatch(setDarkMode());
  }





  return (
    <div className="flex h-14 items-center justify-between border-b px-4 dark:text-gray-100 dark:bg-gray-900">
      <h3 className="text-lg font-medium">Recc Admin Panel</h3>
      <div className="flex items-center gap-2">
        {
          toggleSideBar ?
            <Button variant="ghost" size="icon" className="rounded-full bg-gray-100 dark:bg-gray-800 text-foreground dark:text-gray-100 dark:hover:text-gray-100" onClick={handleToggle}>
              {
                //<DoubleArrowLeftIcon className="h-5 w-5" />
              }
              <div className="menu-icon">
                <FaBars size={15} />
              </div>
              <span className="sr-only">Close</span>
            </Button> :
            <Button variant="ghost" size="icon" className="rounded-full bg-gray-100 dark:bg-gray-800 text-foreground dark:text-gray-100 dark:hover:text-gray-100" onClick={handleToggle}>
              {
                //<DoubleArrowRightIcon className="h-5 w-5 " />
              }
              <div className="menu-icon">
                <FaBars size={15} />
              </div>
              <span className="sr-only">Open</span>
            </Button>
        }
        <div className={`flex items-center gap-4 ${darkMode ? 'dark' : ""}`}>
          <ProfileDropDown />
          <Button
            variant="ghost"
            size="icon"
            onClick={handleDarkMode}
            className="rounded-full bg-gray-100 dark:bg-gray-800 text-foreground dark:text-gray-100 dark:hover:text-gray-100">
            {darkMode ? <SunIcon className="h-5 w-5" /> : <MoonIcon className="h-5 w-5" />}
            <span className="sr-only">Toggle dark mode</span>
          </Button>
        </div>

      </div>
    </div>
  )
};

export default Header;
